module.exports = __webpack_public_path__ + "static/apacheAirflow-a2bde5bda6b0e17e748abbbc353d1c03.svg";